window.cartDiscountStrings = {
  apply: "Aplicar",
  applied: "Descuento aplicado",
  invalid: "Código no válido o no aplicable",
  remove: "Quitar",
  discountLabel: "Descuento"
};

(function ($) {
  'use strict';

  var moneyFormat = (window.theme && window.theme.money_format) || window.money_format || '$';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function fetchCart() {
    return $.getJSON('/cart.js');
  }

  function applyDiscountRequest(code) {
    return $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ discount: code })
    });
  }

  function getAppliedCodes(cart) {
    var apps = cart.cart_level_discount_applications || [];
    return apps.map(function (app) {
      return (app.title || app.code || '').toString();
    }).filter(Boolean);
  }

  function codeWasApplied(cart, code, previousDiscount) {
    var normalized = (code || '').trim().toLowerCase();
    if (!normalized) return false;

    var applied = getAppliedCodes(cart);
    var match = applied.some(function (title) {
      return title.toLowerCase() === normalized;
    });

    if (match) return true;

    var totalDiscount = cart.total_discount || 0;
    if (totalDiscount > (previousDiscount || 0)) return true;

    return false;
  }

  function setLoading($root, loading) {
    $root.toggleClass('cart-discount--loading', loading);
    $root.find('[data-discount-apply]').prop('disabled', loading);
    $root.find('[data-discount-input]').prop('disabled', loading);
  }

  function showMessage($root, text, type) {
    var $msg = $root.find('[data-discount-message]');
    $msg.removeClass('hide cart-discount__message--success cart-discount__message--error');
    if (!text) {
      $msg.addClass('hide').text('');
      return;
    }
    $msg
      .addClass(type === 'success' ? 'cart-discount__message--success' : 'cart-discount__message--error')
      .text(text);
  }

  function renderAppliedList($root, cart) {
    var $list = $root.find('[data-discount-applied]');
    var codes = getAppliedCodes(cart);
    $list.empty();

    if (!codes.length) {
      $list.addClass('hide');
      return;
    }

    codes.forEach(function (code) {
      var $li = $('<li class="cart-discount__applied-item fl f-jcsb f-aic"></li>');
      $li.append($('<span class="cart-discount__applied-code"></span>').text(code));
      $li.append(
        $('<button type="button" class="cart-discount__remove btn--link tdu small"></button>')
          .attr('data-discount-remove', code)
          .text(window.cartDiscountStrings.remove)
      );
      $list.append($li);
    });

    $list.removeClass('hide');
  }

  function updateCartPage(cart) {
    $('#cart_total').html(formatMoney(cart.total_price));

    var $discountRow = $('[data-cart-discount-row]');
    if (!$discountRow.length) {
      $discountRow = $(
        '<div class="fl cart-discount-summary mb10 hide" data-cart-discount-row>' +
          '<span></span>' +
          '<span data-cart-discount-amount></span>' +
        '</div>'
      );
      $discountRow.find('span').first().text(window.cartDiscountStrings.discountLabel);
      $('[data-cart-subtotal-row]').before($discountRow);
    }

    if (cart.total_discount > 0) {
      $discountRow.removeClass('hide');
      $discountRow.find('[data-cart-discount-amount]').html('-' + formatMoney(cart.total_discount));
    } else {
      $discountRow.addClass('hide');
    }

    cart.items.forEach(function (item) {
      var handle = (item.key || '').replace(/:/g, '-');
      var $el = $('#final_price_' + handle);
      if ($el.length) {
        $el.html(formatMoney(item.final_line_price));
      }
    });
  }

  function refreshCartUI(cart) {
    if (typeof CartJS !== 'undefined') {
      CartJS.cart = cart;
      CartJS.render($('[data-cart-view]'), cart);
      $(document).trigger('currency.changed');
    }

    updateCartPage(cart);

    $('[data-cart-discount]').each(function () {
      renderAppliedList($(this), cart);
    });
  }

  function processDiscount($root, code, previousDiscount) {
    setLoading($root, true);
    showMessage($root, '', '');

    return applyDiscountRequest(code)
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        if (code && !codeWasApplied(cart, code, previousDiscount)) {
          showMessage($root, window.cartDiscountStrings.invalid, 'error');
          renderAppliedList($root, cart);
          refreshCartUI(cart);
          return;
        }

        if (code) {
          showMessage($root, window.cartDiscountStrings.applied, 'success');
          $root.find('[data-discount-input]').val('');
        }

        renderAppliedList($root, cart);
        refreshCartUI(cart);
      })
      .fail(function () {
        showMessage($root, window.cartDiscountStrings.invalid, 'error');
      })
      .always(function () {
        setLoading($root, false);
      });
  }

  function initAppliedState() {
    fetchCart().done(function (cart) {
      $('[data-cart-discount]').each(function () {
        renderAppliedList($(this), cart);
      });
      updateCartPage(cart);
    });
  }

  $(function () {
    initAppliedState();

    $(document).on('click', '[data-discount-apply]', function () {
      var $root = $(this).closest('[data-cart-discount]');
      var code = $root.find('[data-discount-input]').val().trim();

      if (!code) {
        showMessage($root, window.cartDiscountStrings.invalid, 'error');
        return;
      }

      fetchCart().done(function (cart) {
        var previousDiscount = cart.total_discount || 0;
        var existing = getAppliedCodes(cart).map(function (c) {
          return c.toLowerCase();
        });
        var combined = existing.indexOf(code.toLowerCase()) === -1
          ? existing.concat([code]).join(',')
          : existing.join(',');
        processDiscount($root, combined, previousDiscount);
      });
    });

    $(document).on('keydown', '[data-discount-input]', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(this).closest('[data-cart-discount]').find('[data-discount-apply]').trigger('click');
      }
    });

    $(document).on('click', '[data-discount-remove]', function () {
      var codeToRemove = $(this).attr('data-discount-remove');
      var $root = $(this).closest('[data-cart-discount]');

      fetchCart().done(function (cart) {
        var previousDiscount = cart.total_discount || 0;
        var remaining = getAppliedCodes(cart).filter(function (c) {
          return c.toLowerCase() !== (codeToRemove || '').toLowerCase();
        });
        processDiscount($root, remaining.join(','), previousDiscount);
      });
    });
  });
})(jQuery);
